import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
import { AlertController, LoadingController, ToastController } from '@ionic/angular';
import { Router } from '@angular/router';
import { EmailsendService } from '../emailsend.service';

@Injectable({
  providedIn: 'root'
})
export class PedidoService {

  private db: any; 
  private storage: any;
  constructor(public alertCtrl: AlertController, public loadingController: LoadingController,
    private toastController: ToastController, 
    private router: Router,              
    public emailsendService: EmailsendService) { 
    this.db = firebase.firestore();
    this.storage = firebase.storage().ref();
  }

async agregarFile(detalleVenta: any, id: any, otrosDatos: any){
  var sf = JSON.stringify(detalleVenta);
  this.agregarProducto(otrosDatos, id, detalleVenta);
}
private basePath = '/uploads';
async agregarProducto(dataObj: any, idComprador: any, detalleVenta: any){      
  dataObj.idComprador = idComprador;
  const loading = await this.loadingController.create({
  message: "Procesando tu Solicitud"
});
await loading.present(); 
try {      

return new Promise((resolve, reject) => {     
  this.db.collection('pedidos').add(dataObj)
    .then((obj: any) => {
      resolve(obj);   
      const str = JSON.stringify(detalleVenta);
      const bytes = new TextEncoder().encode(str);
      const blob = new Blob([bytes], {
          type: "application/json;charset=utf-8"
      });
      var filePath = `${this.basePath}/${obj.id}`;
      var mountainsRef = this.storage.child(filePath);
      loading.message  = 'Guardando tus datos (◔◡◔)';
      setTimeout(() => {
        loading.message = 'Subiendo tus productos (¬‿¬)'
        setTimeout(() => {
          loading.message = 'Ya falta poco ٩(˘◡˘)۶'
          setTimeout(() => {
            loading.message = 'un poco más (͠≖ ͜ʖ͠≖)👌'
          }, 7000);
        }, 7000);
      }, 7000);
      mountainsRef.put(blob).then( (resulto: any) => {
      loading.dismiss();    
      this.AlertCompraSuccess("¡Gracias!", "Puedes rastrear tu pedido copiando el código "+obj.id, obj.id);        
      this.emailsendService.sendEmail(obj.id, dataObj.transaction.email, dataObj.cliente, detalleVenta, dataObj.precio, dataObj.gastosEnvio);
  }).catch((error: any) => {    
    loading.dismiss();
      this.AlertCompra("Lo sentimos :(", "Ocurrió un error: "+error); 
  });
})
    .catch((error: any) => {
      reject(error);
      loading.dismiss();
        this.AlertCompra("Lo sentimos :(", "Ocurrió un error: "+error); 
    });
    
});  
} catch (error) {
loading.dismiss();            
this.AlertCompra("Lo sentimos :(", "Verifica tu conexión: "+error);  
}
loading.dismiss();
}

async AlertCompraSuccess(mensaje: string, subtitulo: string, id: string) {
  const alert = await this.alertCtrl.create({
    header: mensaje,
    subHeader: subtitulo,
    buttons: [      
      {
        text: "Copiar y Rastrear",
        handler: data => {
          this.copiar(id);
          this.router.navigate(['/comosehace/'+id]);
        }
      },
      {
        text: "Cerrar",
        handler: data => {
          this.copiar(id);
          alert.dismiss();
        },
        role: '',
      }
    ]
  });
  await alert.present();
}

async AlertCompra(mensaje: string, subtitulo: string) {
  const alert = await this.alertCtrl.create({
    header: mensaje,
    subHeader: subtitulo,
    buttons: [
      {
        text: "OK",
        handler: data => console.log("ok"),
        role: '',
      }
    ]
  });
  await alert.present();
}

  cajas: any;
async verCajas(): Promise<any>{
  const loading = await this.loadingController.create({
    message: "Cargando cajas ʕ•́ᴥ•̀ʔっ"
  });
  await loading.present();
  let posts: any = [];
  let cont= 0;


  return new Promise((resolve, reject) => {
    this.db.collection('cajas').get().then((querySnapshot: any) => {
   loading.dismiss();
   posts = [];
     querySnapshot.forEach(function(doc: any) {
        const data = doc.data();
        data.id = doc.id
        posts.push(data);
      });        
      if (posts.length > 0) {
        this.cajas = posts;
        resolve(posts);
      } else {           
        this.AlertCompra("¿Sin datos?", "verifique su conexión de internet");
        resolve(null);
      }
    })
    .catch((error: any) => {
      loading.dismiss(); 
      this.AlertCompra("Error.", error);
      reject(error);
    });
  });
 
}

peluches: any;
async verProductos(): Promise<any> {
  let posts: any[] = [];
  return new Promise((resolve, reject) => {
    this.db.collection('productos').get()
      .then((querySnapshot: any) => {
        posts = [];
        let posicion = 0;

        querySnapshot.forEach((doc: any) => {
          const data = doc.data();
          data.id = doc.id;
          data.posicion = posicion;
          posicion++;

          // Convertir stock a número antes de filtrar
          const stockNum = Number(data.stock);
          if (!isNaN(stockNum) && stockNum > 0) {
            posts.push(data);
          }
        });

        if (posts.length > 0) {
          this.peluches = posts;
          resolve(posts);
        } else {
          this.AlertCompra("¿Sin datos?", "No hay productos con stock disponible");
          resolve(null);
        }
      }).catch((error: any) => {
        this.AlertCompra("Error.", error);
        reject(error);
      });
  });
}


async verAnuncios(): Promise<any>{
  let posts: any = [];
  return new Promise((resolve, reject) => {
    this.db.collection('anuncio').get()
    .then((querySnapshot: any) => {
    posts = [];
     querySnapshot.forEach(function(doc: any) {
        const data = doc.data();
        data.id = doc.id
        posts.push(data);
      });
      if (posts.length > 0) {
        resolve(posts);
      }
    });    
  });
}

  accesorios: any;
async verAccesorio(): Promise<any>{
  let posts: any = [];
  let cont= 0;
  return new Promise((resolve, reject) => {
    this.db.collection('accesorio').get()
    .then((querySnapshot: any) => {
   posts = [];
     querySnapshot.forEach(function(doc: any) {
        const data = doc.data();
        data.id = doc.id
        posts.push(data);
      });
      if (posts.length > 0) {
        this.accesorios = posts;
        resolve(posts);
      } else {           
        this.AlertCompra("¿Sin datos?", "verifique su conexión de internet");
        resolve(null);
      }
    }).catch((error: any) => {
     // loading.dismiss(); 
      this.AlertCompra("Error.", error);
      reject(error);
    });
    
  });
 
}

async rastrearPedido(idDocument: string): Promise<any> {
  const loading = await this.loadingController.create({
    message: "Buscando ʕ•́ᴥ•̀ʔっ"
  });
  await loading.present();

  try {
    const docRef = this.db.collection('pedidos').doc(idDocument);
    const docSnapshot = await docRef.get();

    await loading.dismiss();

    if (docSnapshot.exists) {
      const data = docSnapshot.data();
      data.id = docSnapshot.id;
      return data;
    } else {
      this.AlertCompra("No se ha encontrado el pedido", "verifica si el código está bien escrito.");
      return null;
    }
  } catch (error) {
    await loading.dismiss();
    this.AlertCompra("Error.", 'Error de rastreo de pedido');
    throw error;
  }
}

 encode( s: any ) {
	var out = [];
	for ( var i = 0; i < s.length; i++ ) {
		out[i] = s.charCodeAt(i);
	}
	return new Uint16Array( out );
}

async reclamoAlerta(mensaje: string, subtitulo: string, codigo: string) {
  const alert = await this.alertCtrl.create({
    header: mensaje,
    subHeader: subtitulo,
    buttons: [
      {
        text: "Copiar y Cerrar",
        handler: data => this.copiar(codigo),
        role: '',
      },
    ]
  });
  await alert.present();
}

async copiar(texto: string) {
  if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(texto);
      this.mostrarToast("Se ha copiado al portapapeles: "+ texto, 'success');
    } catch (err) {      
    }
  }
}

async mostrarToast(producto: any, color: 'success' | 'danger' | 'warning') {
  const toast = await this.toastController.create({
    message: producto,
    color: color,
    position: 'bottom',
    duration: 2000
  });
  toast.present();
}

async agregarReclamo(dataObj: any){
  const loading = await this.loadingController.create({
  message: "Procesando Reclamo..."
});
await loading.present(); 
try {      

return new Promise((resolve, reject) => {     
  this.db.collection('reclamos').add(dataObj)
    .then((obj: any) => {
      resolve(obj);   
      loading.dismiss();  
        this.reclamoAlerta("Se envió su reclamo, su código de reclamo es: ", obj.id , obj.id);  
    })
    .catch((error: any) => {
      reject(error);
      loading.dismiss();
        this.AlertCompra("Lo sentimos :(", "Ocurrió un error: "+error); 
    });
    
});  
} catch (error) {
loading.dismiss();            
this.AlertCompra("Lo sentimos :(", "ocurrió un error: "+error);  
}
loading.dismiss();
}


async getDistritos(): Promise<any[]> {
  let distritos: any[] = [];
  return new Promise((resolve, reject) => {
    this.db.collection('distritos').get()
      .then((querySnapshot: any) => {
        distritos = [];
        querySnapshot.forEach((doc: any) => {
          const data = doc.data();
          data.id = doc.id;
          distritos.push(data);
        });
        resolve(distritos);
      })
      .catch((error: any) => {
        this.AlertCompra("Error.", error);
        reject(error);
      });
  });
  }
  
}
